export default {
    // récuperer toutes les grilletarifaires dans la base de données 
    get_all_grilletarifaires(serverParams){
        return axios.post('/grilletarifaire/list?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les grilletarifaires dans la base de données 
    post_grilletarifaires(grilletarifaire){
        return axios.post('/grilletarifaires',grilletarifaire, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_grilletarifaires(libelle,grilletarifaire){
        return axios.put('/grilletarifaires/' + libelle,grilletarifaire, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_grilletarifaires(libelle){
        return axios.get('/grilletarifaires/'+libelle, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_grilletarifaires(id){
        return axios.delete('/grilletarifaires/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}